<template>
  <h1 class="document-title">
    {{ documentTitle }}
  </h1>
</template>

<script setup lang="ts">
defineProps<{
  documentTitle?: string;
}>();
</script>

<style lang="scss">
.document-title {
  font-size: w.font('large');
  font-weight: w.weight('medium');
  color: w.color('text');
  width: 100%;
  padding: calc(w.size('layout-padding') / 2) w.size('layout-padding');
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;

  @include w.media-lg {
    padding: calc(w.size('layout-padding--lg') / 2) w.size('layout-padding--lg');
    font-size: w.font('regular');
  }

  @include w.media-md {
    padding: calc(w.size('layout-padding--md') / 2) w.size('layout-padding--md');
  }
}
</style>
